module.exports = "/_next/static/images/truck-1-eead5d6b4bc4c93b2747f18c5d22e5bb.png.webp";